import { jsx as s } from "react/jsx-runtime";
import { c as B, b } from "../../vendor-CwFtm_qv.js";
import { forwardRef as I } from "react";
import { getSpacingClasses as g } from "../../utils/getSpacingClasses/index.js";
import { omit as x } from "../../utils/omit/index.js";
import { BaseIcon as y } from "../BaseIcon/index.js";
import { isIconName as $ } from "../BaseIcon/typeGuards.js";
import { b as r } from "../../shared-button.module-BT8NBm4o.js";
import { withTooltip as h } from "../Tooltip/withTooltip.js";
import '../../assets/index4.css';const q = "e9osBq_iconButton", w = "e9osBq_md", N = "e9osBq_sm", m = {
  iconButton: q,
  md: w,
  sm: N
};
function _({ size: t = "md", icon: o, variant: c = "primary", m: e, mt: i, mr: a, mb: f, ml: p, ...u }, l) {
  const d = B({
    [r.baseButton]: !0,
    [r[c]]: !0,
    [m.iconButton]: !0,
    [m[t]]: !0,
    ...g({ m: e, mt: i, mr: a, mb: f, ml: p })
  }), n = $(o);
  return n || console.warn(`${String(o)} is not a valid icon name for IconButton.`), /* @__PURE__ */ s(
    b,
    {
      ...x(u, ["className", "style", "isPending", "slot", "type", "children"]),
      type: "button",
      className: d,
      ref: l,
      children: n && /* @__PURE__ */ s(y, { icon: o, size: t })
    }
  );
}
const A = h(I(_));
export {
  A as IconButton
};
//# sourceMappingURL=index.js.map
